module.exports = __webpack_public_path__ + "img/20f10.9d4df875.jpg";